import HowSystemWorks from './HowSystemWorks';

export default HowSystemWorks;
